import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCampanha } from 'campanha/src/store/campanhaReducer';
import * as S from './aprovarPedidoStyle';
import { View } from 'base/src/components/Basic/View/view';
import PagedResgates from '../aprovarPedido/components/pagedResgate';
import ViewContainer from '../viewContainer/viewContainer';
import { useEffect } from 'react';
import { GetCarteiraUsuario } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { Redirect } from 'base/src/utils/routeUtil';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';
import { PageBanner } from 'base/src/components/PageBanner';
import { useCampanhaId } from '../../hooks/useCampanhaId';

const connector = connectUtil(
  (state: RootStateCampanha) => ({}),
  { GetCarteiraUsuario }
);

export interface AprovarPedidoProps extends PropsFromRedux<typeof connector> { }

function AprovarPedido(props: AprovarPedidoProps) {
  const campanhaId = useCampanhaId();

  useEffect(() => {
    props.GetCarteiraUsuario(() => { Redirect(GetAuthRoute()) });
  }, []);

  return (
    <ViewContainer>
      <S.Header>
        <PageBanner showGoBack={false} title='Aprovar Pedidos' subtile='Aprove e gerencie os resgates da campanha.' />
      </S.Header>
      <View>
        <PagedResgates
          take={5}
          campanhaId={Number(campanhaId)}
        />
      </View>
    </ViewContainer>
  );
}

export default connector(AprovarPedido);
